import { render, staticRenderFns } from "./ChangeRequestsStatusModal.vue?vue&type=template&id=f160282c&scoped=true&"
import script from "./ChangeRequestsStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestsStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f160282c",
  null
  
)

export default component.exports